import { render, staticRenderFns } from "./InsurerView.vue?vue&type=template&id=9f387848"
import script from "./InsurerView.vue?vue&type=script&lang=js"
export * from "./InsurerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f387848')) {
      api.createRecord('9f387848', component.options)
    } else {
      api.reload('9f387848', component.options)
    }
    module.hot.accept("./InsurerView.vue?vue&type=template&id=9f387848", function () {
      api.rerender('9f387848', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurer/InsurerView.vue"
export default component.exports